/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RotorWingShiftsResponse } from '../../models/rotor-wing-shifts-response';
import { UpdateRotorWingShiftStatusRequest } from '../../models/update-rotor-wing-shift-status-request';

export interface UpdateRotorWingShiftStatus$Params {
      body: UpdateRotorWingShiftStatusRequest
}

export function updateRotorWingShiftStatus(http: HttpClient, rootUrl: string, params: UpdateRotorWingShiftStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<RotorWingShiftsResponse>> {
  const rb = new RequestBuilder(rootUrl, updateRotorWingShiftStatus.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RotorWingShiftsResponse>;
    })
  );
}

updateRotorWingShiftStatus.PATH = '/api/scheduler/daily-line-schedule/rotor-wing/shifts';
